import { IEvent, IHost } from "@Interfaces";
import { GST_STATUS } from "repoV2/features/Listing/Listing.constants";
import { getCountryIsIndia } from "repoV2/utils/common/location/location";
import { getHasToCollectFullAddressForStripe } from "./getHasToShowFullAddress";

export const getShowGstOption = ({
    event,
    eventData,
    host,
}: {
    event: IEvent.IStore;
    eventData: IEvent.IEventData;
    host: IHost.IStore;
}) => {
    const hostData = host?.dataHost?.profile_data || ({} as IHost.IHostData);

    /**
     * If this flag is true, the payment flow will assume that stripe is being used for an international creator
     */
    const hasToCollectFullAddressForStripe =
        getHasToCollectFullAddressForStripe({
            eventData,
            hostData,
            event,
        });

    const gstState = eventData?.gst_state;
    // We show gst fields only if gst is enabled, user is domestic,
    // an gst state is 'not inapplicable'.
    // We don;t just check for 'gstState === GST_STATUS.INAPPLICABLE' for the
    // case where gstState might come undefined or null
    const isGSTStateNotApplicable =
        gstState === GST_STATUS.INCLUSIVE || gstState === GST_STATUS.EXCLUSIVE;

    // Show GST option only if gst state is either inclusive or exclusive, and
    // if get gst info is true, and the user is domestic
    return !!(
        isGSTStateNotApplicable &&
        hostData?.get_gst_info &&
        getCountryIsIndia(host.country.name) &&
        !hasToCollectFullAddressForStripe
    );
};
